class ResizeHandler {
    constructor () {
        this.activeEvent = '';
        this.event = [];
        this.eventNav = [];

        this.debug = true;

        this.dimensions = {
            width: window.innerWidth,
            height: window.innerHeight
        };

        this.specialEvents = {
            sizeMobile: {
                min: 320,
                max: 767
            },
            sizeTablet: {
                min: 768,
                max: 1023
            },
            sizeDesktop: {
                min: 1024,
                max: 1439
            },
            sizeWide: {
                min: 1440,
                max: 9999
            }
        };

        this.$navigationEvents = {
            navMobile: {
                min: 320,
                max: 1279
            },
            navDesktop: {
                min: 1280,
                max: 9999
            }
        };
    }

    init () {
        Object.keys(this.specialEvents).forEach((value, index) => {
            if (typeof (Event) === 'function') {
                this.event[index] = new Event(value);
            } else { // IE 11 case
                this.event[index] = document.createEvent('Event');
                this.event[index].initEvent(value, true, true);
            }
        });

        Object.keys(this.$navigationEvents).forEach((value, index) => {
            if (typeof (Event) === 'function') {
                this.event[index] = new Event(value);
            } else { // IE 11 case
                this.event[index] = document.createEvent('Event');
                this.event[index].initEvent(value, true, true);
            }
        });

        this.events();
    }

    events () {
        let resizeTimer = '';
        let lastResizeFireTime = 0;

        window.addEventListener('resize', () => {
            const now = new Date().getTime();
            const minResizeTime = 100;

            if (!resizeTimer) {
                if (now - lastResizeFireTime > (3 * minResizeTime)) {
                    lastResizeFireTime = now;

                    this.dimensions.width = window.innerWidth;
                    this.dimensions.height = window.innerHeight;
                    this.fireEvents();
                }

                resizeTimer = setTimeout(() => {
                    resizeTimer = null;
                    lastResizeFireTime = new Date().getTime();

                    this.dimensions.width = window.innerWidth;
                    this.dimensions.height = window.innerHeight;
                    this.fireEvents();
                }, minResizeTime);
            }
        });
    }

    fireEvents () {
        Object.keys(this.specialEvents).forEach((value, index) => {
            if (this.dimensions.width >= this.specialEvents[value].min && this.dimensions.width <= this.specialEvents[value].max) {
                if (this.activeEvent !== value) {
                    this.activeEvent = value;
                    document.dispatchEvent(this.event[index]);
                }
            }
        });

        Object.keys(this.$navigationEvents).forEach((value, index) => {
            if (this.dimensions.width >= this.$navigationEvents[value].min && this.dimensions.width <= this.$navigationEvents[value].max) {
                if (this.activeEvent !== value) {
                    this.activeEvent = value;
                    document.dispatchEvent(this.event[index]);
                }
            }
        });
    }

    add (event) {
        if (typeof event !== 'object') { return false; }

        Object.keys(event).forEach((value) => {
            this.specialEvents[value] = {};
            this.specialEvents[value].min = event[value].min;
            this.specialEvents[value].max = event[value].max;
        });

        Object.keys(event).forEach((value) => {
            this.$navigationEvents[value] = {};
            this.$navigationEvents[value].min = event[value].min;
            this.$navigationEvents[value].max = event[value].max;
        });
    }
}

export { ResizeHandler };
